import { FC, ReactNode } from 'react';

import * as S from './DetailPanel.styles';

export type PanelType = 'profit' | 'loss' | 'info' | 'ship';

interface DetailPanelProps {
  isActive?: boolean;
  type?: PanelType;
  className?: string;
  children: ReactNode;
}

export const DetailPanel: FC<DetailPanelProps> = ({
  isActive = false,
  type,
  className,
  children,
}) => {
  return (
    <S.Container $isActive={isActive} $type={type} className={className}>
      <S.Corner className="corner tl" />
      <S.Corner className="corner tr" />
      <S.Corner className="corner bl" />
      <S.Corner className="corner br" />
      {children}
    </S.Container>
  );
};

interface DetailHeaderProps {
  children: ReactNode;
}

export const DetailHeader: FC<DetailHeaderProps> = ({ children }) => {
  return <S.Header>{children}</S.Header>;
};

interface DetailBodyProps {
  children: ReactNode;
}

export const DetailBody: FC<DetailBodyProps> = ({ children }) => {
  return <S.Body>{children}</S.Body>;
};

interface DetailBadgeProps {
  type?: PanelType;
  children: ReactNode;
}

export const DetailBadge: FC<DetailBadgeProps> = ({ type = 'info', children }) => {
  return <S.Badge $type={type}>{children}</S.Badge>;
};

interface DetailCloseButtonProps {
  onClick?: () => void;
}

export const DetailCloseButton: FC<DetailCloseButtonProps> = ({ onClick }) => {
  return <S.CloseButton onClick={onClick}>✕</S.CloseButton>;
};
